import { render } from "./CreateContactComponent.vue?vue&type=template&id=523b1386&scoped=true"
import script from "./CreateContactComponent.vue?vue&type=script&lang=js"
export * from "./CreateContactComponent.vue?vue&type=script&lang=js"

import "./CreateContactComponent.vue?vue&type=style&index=0&id=523b1386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523b1386"]])

export default __exports__